import { render, staticRenderFns } from "./FileManager.vue?vue&type=template&id=2bb1e08d&scoped=true&"
import script from "./FileManager.vue?vue&type=script&lang=js&"
export * from "./FileManager.vue?vue&type=script&lang=js&"
import style0 from "./FileManager.vue?vue&type=style&index=0&id=2bb1e08d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb1e08d",
  null
  
)

export default component.exports